const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class PoliticsOfStrength extends Event {
    constructor(){
        super(
            Age.Age2,
            EventNames.PoliticsOfStrength,
            "The strongest civilization draws 5 military cards. The weakest civilization discards 3 military cards. In the game-ending age, culture is scored or lost instead.",
            {}
        )
    }
}

module.exports = PoliticsOfStrength;